// pd1.js - Patio Door Configuration 1
// Wrapper component that uses the PD template with specific configuration

import React from 'react';
import PD from './pd';
import { pageConfigs } from '../../configs';

// Import control map sections when they are created
// import { getConfigurationSection } from './controlMaps/configurationSection';
// import { getSizingSection } from './controlMaps/sizingSection';
// import { getGlassSection } from './controlMaps/glassSection';
// import { getFinishSection } from './controlMaps/finishSection';
// import { getInstallationSection } from './controlMaps/installationSection';
// import { getNotesSection } from './controlMaps/notesSection';
// import { getDiscountsSection } from './controlMaps/discountsSection';

// Import drawing component when created
// import DrawPatioDoor from '../../DrawPatioDoor';

const PD1 = () => {
  // Define which control map sections this configuration uses
  // Uncomment and add sections as they are created
  const controlMapSections = [
    // getConfigurationSection,
    // getSizingSection,
    // getGlassSection,
    // getFinishSection,
    // getInstallationSection,
    // getNotesSection,
    // getDiscountsSection,
  ];

  return (
    <PD
      config={pageConfigs.pd1}
      controlMapSections={controlMapSections}
      // DrawComponent={DrawPatioDoor}
      documentType="patiodoors"
      itemPath="patiodoors/pdt/pd1"
    />
  );
};

export default PD1;
